import OrdersMain from "../components/orders/OrdersMain";

function Orders() {
  return <OrdersMain />;
}

export default Orders;
